// extracted by mini-css-extract-plugin
export default {"formError":"Resource_formError__UxB-v","brandButton":"Resource_brandButton__8qugM"};